import { render, staticRenderFns } from "./EventoCard.vue?vue&type=template&id=2c377763"
import script from "./EventoCard.vue?vue&type=script&lang=js"
export * from "./EventoCard.vue?vue&type=script&lang=js"
import style0 from "./EventoCard.vue?vue&type=style&index=0&id=2c377763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports